import { SINGLE_ITEMS_API_BASE, CODE_PARAM, SINGLE_ITEMS_API_KEY } from '../Constants/APIConstants';

const getItems = (itemNo) => {
    let url = new URL(`${SINGLE_ITEMS_API_BASE}${itemNo}`);
    url.searchParams.append(CODE_PARAM, SINGLE_ITEMS_API_KEY);

    return fetch(url, {});
}

export default getItems;